export default __webpack_public_path__ + "static/media/2001-IMcover.35d00d7b.jpg";